module.exports = __webpack_public_path__ + "src/assets/textures/env/wheel_barrel/wheel_barrel_512_bake.png";